<template>
  <div
    v-if="!atividadeSelecionada"
    class="main-atv"
  >
    <Breadcrumb
      :items="breadcrumbItems"
      v-if="!acaoId"
    />
    <FiltrosComponent
      :isCoordenador="isCoordenador"
      :nomeTela="'atividade'"
      :filtrosIniciais="filtrosSelecionados"
      @pesquisar="executarBusca"
    />
  </div>
  <div
    id="atividades"
    :class="{ 'single-item': atividades.length === 1 }"
  >
    <div
      id="atividade"
      class="transform-container"
      v-for="dadosAtividade in atividades"
      :key="dadosAtividade.id"
      v-if="!isLoading"
    >
      <AtividadesCard
        :atividade="dadosAtividade"
        :isCoordenador="isCoordenador"
      />
    </div>
  </div>
  <AvisoListagem v-if="!isLoading && atividades.length === 0">
    Nenhuma atividade encontrada
  </AvisoListagem>

  <Carregamento v-if="isLoading" />

  <PaginacaoComponent
    :total-paginas="totalPages"
    @mudar-pagina="carregarPagina"
  />
</template>

<script setup>
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";

import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import FiltrosComponent from "@/components/common/FiltrosComponent.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import AtividadesCard from "./AtividadesCard.vue";
import { useAtividades } from "@/composables/useAtividades.js";
import AvisoListagem from "../common/AvisoListagem.vue";

const props = defineProps({
  isAtiva: Boolean,
  isCoordenador: Boolean,
  acaoId: String,
});

const emit = defineEmits(["paginaAberta"]);

const route = useRoute();
const { atividades, isLoading, totalPages, fetchAtividadesComFiltros } =
  useAtividades();

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Atividades", to: `Atividades` },
  ];
});

function executarBusca(termo) {
  const query = { ...route.query };
  if (termo && termo.trim()) {
    query.q = termo.trim();
  } else {
    delete query.q;
  }
  delete query.page;

  router.push({ query });
}

function carregarPagina(pagina) {
  const query = { ...route.query };
  query.page = pagina;
  router.push({ query });
}

watch(
  () => route.query,
  (newQuery) => {
    const page = newQuery.page ? Number(newQuery.page) : 0;

    const filtrosSelecionados = {
      status: newQuery.status ? newQuery.status : "",
      modalidade: newQuery.modalidade ? newQuery.modalidade : "",
      tipo: newQuery.tipo ? newQuery.tipo : "",
      categorias: newQuery.categorias ? newQuery.categorias.split(",") : [],
      unidadeId: newQuery.unidadeId || null,
      busca: newQuery.q || "",
    };
    fetchAtividadesComFiltros(
      page,
      6,
      filtrosSelecionados,
      props.acaoId || null
    );
  },
  { immediate: true }
);
</script>

<style scoped>
.main-atv {
  width: 100%;
}

.main-atv,
#atividades {
  width: 100% !important;
  max-width: none !important;
}

#atividades {
  display: grid;
  grid-template-columns: repeat(2, minmax(560px, 1fr));
  gap: 1rem;
  justify-items: center;
  width: 100% !important;
  max-width: none !important;
}

#atividades.single-item {
  justify-items: start;
}

#atividade {
  display: flex;
  background-color: #ffffff;
  color: var(--preto);
  width: 100%;
  height: 235px;
  max-height: 235px;
  border-radius: 12px;
  cursor: pointer;
  border: 1.5px solid hsl(258, 30%, 90%);
  box-shadow: 0 4px 16px -2px rgba(54, 32, 101, 0.08), 0 2px 6px -1px rgba(54, 32, 101, 0.04);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

#atividade:hover {
  transform: translateY(-2px);
  border-color: hsl(258, 45%, 78%);
  box-shadow: 0 10px 24px -3px rgba(54, 32, 101, 0.14), 0 4px 10px -2px rgba(54, 32, 101, 0.06);
}
</style>
